export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return
  }

  const authStore = resolveAuthStore()
  if (!authStore) {
    return
  }
  
  // Check if route requires auth
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return navigateTo('/login')
  }
  
  // Check for role-based access
  const requiredRole = to.meta.requiredRole as string | undefined
  if (requiredRole && authStore.userRole !== requiredRole) {
    return navigateTo('/unauthorized')
  }
}) 